module.exports = __webpack_public_path__ + "static/media/winA.db559289.png";